export default __webpack_public_path__ + "static/media/slider_inicio_4.4cc44f52.jpg";